import { render, staticRenderFns } from "./AthleteVideoHighlightReel.vue?vue&type=template&id=7b0488c4&scoped=true&"
import script from "./AthleteVideoHighlightReel.vue?vue&type=script&lang=ts&"
export * from "./AthleteVideoHighlightReel.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteVideoHighlightReel.vue?vue&type=style&index=0&id=7b0488c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0488c4",
  null
  
)

export default component.exports